import { Close } from '@mui/icons-material';
import { Alert, Box, Collapse, IconButton, Stack, Typography } from '@mui/material';
import useLocalStorage from '@src/app/hooks/useLocalStorage';
import { FC } from 'react';

export const DashboardAlert: FC = (): JSX.Element => {
  const [alertNews, setAlertNews] = useLocalStorage<boolean>('alertNews', true);

  const close = () => setAlertNews(false);

  return (
    <Box mt={1}>
      <Collapse in={Boolean(alertNews)}>
        <Alert
          action={
            <IconButton onClick={close}>
              <Close />
            </IconButton>
          }
          sx={{ mb: 2 }}
          severity="info"
        >
          <Stack direction="column" spacing={2}>
            <Typography>
              There’s a known issue affecting portfolio display when logging into the mobile app. Our team is actively fixing this as a high priority.
            </Typography>
            <Typography>In the meantime, your web portal will continue to work as normal.</Typography>
          </Stack>
        </Alert>
      </Collapse>
    </Box>
  );
};
